import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {UAParser} from 'ua-parser-js';

export interface FehlerBoxItem {
  message: string;
  label: string;
  elementId?: string;
}

@Component({
    selector: 'wba-fehler-box',
    templateUrl: './fehler-box.component.html',
    standalone: false
})
export class FehlerBoxComponent {

  @Input() id: string;
  @Input() boxTitle = 'Aufgetretene Fehler';

  link = false;
  jumpToFirstInvalidElement: HTMLElement = null;
  errorList: FehlerBoxItem[] = [];

  @ViewChild('firstButton') firstButton: ElementRef<HTMLAnchorElement>;

  static getLabel(elem) {
    if (elem.dataset.errorLabel) {
      return elem.dataset.errorLabel;
    }
    const htmlElement: HTMLElement | null = document.querySelector(`[for="${elem.id}"]`);
    return htmlElement ? htmlElement.innerText.replaceAll('*', '') : '';
  }

  jumpToInvalidField() {
    if (this.jumpToFirstInvalidElement) {
      this.jumpToFirstInvalidElement.scrollIntoView({inline: 'center', block: 'center', behavior: 'smooth'});
      this.jumpToFirstInvalidElement.focus({preventScroll: true});
    } else {
      const firstInvalidField: HTMLElement = document.querySelectorAll('[data-has-error="true"]')[0] as HTMLElement;
      if (firstInvalidField) {
        firstInvalidField.scrollIntoView({inline: 'center', block: 'center', behavior: 'smooth'});
        firstInvalidField.focus({preventScroll: true});
      }
    }
  }

  showCustom(errors: FehlerBoxItem[], invalidField?) {
    this.errorList = errors;
    setTimeout(() => this.focusFirstButton());
    if (invalidField) {
      this.jumpToFirstInvalidElement = invalidField;
    }
  }

  show(preventFirstButtonFocus = false) {
    this.errorList = [];
    const invalidFields = document.querySelectorAll<HTMLElement>('[data-has-error="true"]');
    invalidFields.forEach((elem: HTMLElement) => {
      if (elem.dataset.hasError) {
        const label = FehlerBoxComponent.getLabel(elem);
        const message = elem.dataset.errorMessage;
        const elementId = elem.id;
        this.errorList.push({message, label, elementId});
      }
    });
    if (!preventFirstButtonFocus) {
      setTimeout(() => this.focusFirstButton());
    }
  }

  jumpTo(id) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({inline: 'center', block: 'center', behavior: 'smooth'});
      element.focus({preventScroll: true});
    }
  }

  private focusFirstButton() {
    if (this.firstButton) {
      const ua = new UAParser();
      if (['IE', 'Safari'].includes(ua.getBrowser().name)) {
        window.scrollTo(0, 0);
      } else {
        this.firstButton.nativeElement.scrollIntoView({inline: 'center', block: 'center', behavior: 'smooth'});
      }
      this.firstButton.nativeElement.focus({preventScroll: true});
    }
  }

}
